import { defineMessages } from 'react-intl'
import Validation from '../lib/validation'
import { roles } from '../config'

export const validateCreate = (data) => {
  const validator = new Validation(data)
  validator.isRequired('email', messages.emailRequired)
  //validator.isRequired('name', messages.nameRequired)
  validator.isRequired('password', messages.passwordRequired)
  validator.isEmail('email', messages.emailFormat)
  return validator.validate()
}

export const validateUpdate = (data) => {
  const validator = new Validation(data)
  validator.isRequired('email', messages.emailRequired)
  validator.isEmail('email', messages.emailFormat)
  return validator.validate()
}

export const validateUpdateMe = (data) => {
  const validator = new Validation(data)
  validator.isEmail('campaignEmail', messages.emailFormat)
  return validator.validate()
}

export const validateLanguagesSelect = (data) => {
  const validator = new Validation(data)
  /*
  validator.isRequired('userLanguage', messages.languageRequired)
  validator.isRequired('foreignLanguage', messages.foreignLanguageRequired)
  */
  return validator.validate()
}

export const validateChangePassword = (data) => {
  const validator = new Validation(data)
  validator.isRequired('password', messages.passwordRequired)
  validator.isRequired('oldPassword', messages.oldPasswordRequired)
  return validator.validate()
}

const messages = defineMessages({
  emailRequired: {
    id: 'validations.users.emailRequired',
    defaultMessage: 'Email je povinný.',
  },
  passwordRequired: {
    id: 'validations.users.passwordRequired',
    defaultMessage: 'Heslo je povinné.',
  },
  oldPasswordRequired: {
    id: 'validations.users.oldPasswordRequired',
    defaultMessage: 'Aktuální heslo je povinné.',
  },
  nameRequired: {
    id: 'validations.users.nameRequired',
    defaultMessage: 'Jméno je povinné.',
  },
  roleRequired: {
    id: 'validations.users.roleRequired',
    defaultMessage: 'Role je povinná.',
  },
  emailFormat: {
    id: 'validations.users.emailFormat',
    defaultMessage: 'Email není ve správném formátu.',
  },
  foreignLanguageRequired: {
    id: 'validations.users.foreignLanguageRequired',
    defaultMessage: 'Cudzí jazyk je povinný.',
  },
  languageRequired: {
    id: 'validations.users.languageRequired',
    defaultMessage: 'Jazyk uživateľa je povinný.',
  },
  learningLanguageRequired: {
    id: 'validations.users.learningLanguageRequired',
    defaultMessage: 'Jazyk, ktorý sa chcete naučiť je povinný.',
  },
})



// WEBPACK FOOTER //
// ./src/common/users/validations.js